import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, IconButton, Modal, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface RideSideDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  width?: number;
}

const RideSideDrawer: React.FC<RideSideDrawerProps> = ({ open, onClose, title, subtitle, children, width }) => {

  const [selectedTab, setSelectedTab] = useState(0);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          height: 'calc(100% - 30px)',
          width: width ? width : 500,
          bgcolor: 'background.paper',
          boxShadow: 3,
          p: 4,
          overflowY: 'auto',
          m: 2,
          borderRadius: 1
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography id="token-modal-title" variant="h6" component="h2">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
        {children}
      </Box>
    </Modal>
  );
};

export default RideSideDrawer;